export default function CampaignDTO(compaign) {
  var p = {};

  if (compaign) {
    p = {
      id: compaign.id,
      externalId: compaign.externalId,
      manufacturerId: compaign.manufacturerId,
      downlinkChannelEnum: compaign.downlinkChannelEnum,
      downlinkModulationEnum: compaign.downlinkModulationEnum,
      campaingEndDate: compaign.campaingEndDate,
      transmitterFirmwareId: compaign.transmitterFirmwareId,
      createdDate: compaign.createdDate,
      statusEnum: compaign.statusEnum,
      failureErrorDetail: compaign.failureErrorDetail,
      description: compaign.description,
      firmwareversion: compaign.transmitterFirmware.firmwareVersion,
      manufacturerExternalId: compaign.manufacturer.externalId,
    };
  }
  return p;
}
